export default __webpack_public_path__ + "static/media/Ecommerce_My_Clean_Assist_Key.8309bdd4.png";